import { refreshTimeout } from '../constants'
import { onVisibilityChange } from '../helpers/DOM'
import Logger from '../helpers/Logger'
import { TimedFunction } from '../helpers/TimedFunction'
import { Slot } from '../slots/Slot'
import Refresh from './Refresh'

export default class Refreshable {
  private _viewable = true
  private readyToRefresh: boolean
  private refreshFunction: TimedFunction
  private url: string
  private removeVisibilityListener: () => void

  constructor(readonly slot: Slot, private refresh: Refresh) {
    Logger.debug(
      `Creating Refreshable for slot`,
      slot,
      `in ${(slot.refreshTime as number) * 1000}`
    )

    this.url = window.location.href

    this.refreshFunction = new TimedFunction(
      () => this.onRefreshTimePassed(),
      slot.refreshTime
    )

    // onVisibilityChange returns a function that will removed the listeners it created when called.
    this.removeVisibilityListener = onVisibilityChange({
      onHidden: () => {
        Logger.debug(`Pausing refreshable:`, slot)
        this.refreshFunction.pause()
      },
      onVisible: () => {
        Logger.debug(`Restarting refreshable:`, slot)
        this.refreshFunction.start()
      }
    })
  }

  set viewable(value: boolean) {
    if (value && this.readyToRefresh) {
      this.refreshSlot()
      this.resetRefreshable()
    }
    this._viewable = value
  }

  private onRefreshTimePassed(): void {
    this.readyToRefresh = true
    if (this._viewable) {
      this.refreshSlot()
      this.resetRefreshable()
    }
  }

  private resetRefreshable(): void {
    this.removeVisibilityListener()
    this.refresh.registry[this.slot.id] = null
  }

  private refreshSlot(): void {
    // If the URL has changed from what it was before for this refreshable (e.g. an SPA changed routes)
    // reset the slot.refreshes count.
    const currentUrl = window.location.href
    if (this.url !== currentUrl) {
      this.slot.refreshes = 1
    } else {
      this.slot.refreshes++
    }

    this.readyToRefresh = false

    // We don't want to refresh if it's a Native Ad because there is no good way to cleanup the old ad
    if (this.slot.adType === 'prebidNative') {
      return
    }

    const timeout = this.slot.timeout || refreshTimeout()
    this.refresh.prebidFacade.requestBids([this.slot], timeout)
  }
}
